var map = {
	"./AlooGobi.png": 3132,
	"./BainganBharta.png": 9768,
	"./ButterChicken.png": 2433,
	"./ChanaMasala.png": 1616,
	"./ChickenBiryani.png": 5721,
	"./ChickenChowmein.png": 3419,
	"./ChickenCurry.png": 7018,
	"./ChickenMasala.png": 8084,
	"./ChickenTikka.png": 4871,
	"./ChineseFriedRice.png": 5978,
	"./Coffee.png": 6092,
	"./ColdCoffee.png": 4134,
	"./DalMakhani.png": 6454,
	"./DalTadka.png": 3094,
	"./Entrance.png": 1750,
	"./FishCurry.png": 1897,
	"./GoanFishCurry.png": 3824,
	"./GulabJamun.png": 7902,
	"./HakkaNoodles.png": 8300,
	"./Hero.png": 9764,
	"./IcedTea.png": 169,
	"./JeeraRice.png": 2002,
	"./KeemaMatar.png": 8974,
	"./KungPaoChicken.png": 3092,
	"./LambRoganJosh.png": 9323,
	"./LambShank.png": 1625,
	"./Lassi.png": 6546,
	"./Lemonade.png": 2799,
	"./MangoJuice.png": 3250,
	"./MangoLassi.png": 6802,
	"./MasalaChai.png": 596,
	"./MasalaSoda.png": 9936,
	"./MuttonKorma.png": 9691,
	"./PalakPaneer.png": 9946,
	"./PaneerButterMasala.png": 3230,
	"./PrawnMasala.png": 5317,
	"./Regular.png": 4362,
	"./Regular1.png": 7945,
	"./Regular2.png": 6978,
	"./SaffronSpice.jpeg": 2278,
	"./Samosa.png": 5176,
	"./SeekhKebab.png": 6351,
	"./Special.png": 8127,
	"./Special1.png": 2422,
	"./Special2.png": 6397,
	"./SpringRolls.png": 7747,
	"./SweetAndSourChicken.png": 128,
	"./SweetLassi.png": 5864,
	"./TandooriChicken.png": 1405,
	"./VegChowmein.png": 8580,
	"./VegKoftaCurry.png": 6998,
	"./VegManchurian.png": 968,
	"./VegetableKurma.png": 2563,
	"./VegetablePulao.png": 2792,
	"./VideoThumbnail.png": 6887,
	"./Vip.png": 2255,
	"./Vip1.png": 2534,
	"./Vip2.png": 2861,
	"./default-profile.png": 9665,
	"./vegetableBiriyani.png": 7706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9291;